export var HttpStatusCodeEnum;
(function (HttpStatusCodeEnum) {
    HttpStatusCodeEnum[HttpStatusCodeEnum["OK"] = 200] = "OK";
    HttpStatusCodeEnum[HttpStatusCodeEnum["UnAuthorized"] = 401] = "UnAuthorized";
    HttpStatusCodeEnum[HttpStatusCodeEnum["InternalServerError"] = 500] = "InternalServerError";
    HttpStatusCodeEnum[HttpStatusCodeEnum["BadRequest"] = 400] = "BadRequest";
    HttpStatusCodeEnum[HttpStatusCodeEnum["Forbidden"] = 403] = "Forbidden";
    HttpStatusCodeEnum[HttpStatusCodeEnum["NotFound"] = 404] = "NotFound";
    HttpStatusCodeEnum[HttpStatusCodeEnum["Conflict"] = 409] = "Conflict";
})(HttpStatusCodeEnum || (HttpStatusCodeEnum = {}));
